/* src/app/activity/strava-form/strava-form.component.scss */
.info {
  text-align: justify;
}
/*# sourceMappingURL=strava-form.component.css.map */
